import { createFileRoute } from '@tanstack/react-router'
import LaborContracts from '@/features/labor-contracts'

export const Route = createFileRoute('/_authenticated/labor-contracts')({
  component: LaborContracts,
}) 